export const config = {
	apiKey: "AIzaSyACv40LFHJ_y1QqPs40bCxfRLwOiY4KBr4",
	authDomain: "swipe-app-de-hoeven.firebaseapp.com",
	projectId: "swipe-app-de-hoeven",
	storageBucket: "swipe-app-de-hoeven.firebasestorage.app",
	messagingSenderId: "361327778905",
	appId: "1:361327778905:web:f20ab8e8fd22857c572548",
};
